class FilterTypes {
  static size() {
    return 'size';
  }

  static category() {
    return 'category';
  }

  static designer() {
    return 'designer';
  }

  static season() {
    return 'season';
  }
}

export default FilterTypes;
